import { PagedSearch } from '../../../shared/index';

/**
 * search fields to search for voter voice officials
 */
export class OfficialSearch extends PagedSearch {}
